module.exports = __webpack_public_path__ + "f382e0bb94da69e8272dbb050c4fe3ce.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/atlassian_2022_chart.png
// module id = 1636
// module chunks = 0